import definition from './translation.service';

export default {
    name: 'TranslationService',
    definition
};
